import { render } from "./bgicon.vue?vue&type=template&id=6ef5fe98"
import script from "./bgicon.vue?vue&type=script&lang=js"
export * from "./bgicon.vue?vue&type=script&lang=js"

import "./bgicon.vue?vue&type=style&index=0&id=6ef5fe98&lang=scss"

import exportComponent from "D:\\Project\\DeepLink\\DeepLinkWebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__